export default __webpack_public_path__ + "static/media/delivery.2f0b912c.svg";